"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_3 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_4 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_5 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    key: 0,
    class: "text-center"
};
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    src: "/images/loading.svg",
    alt: "loading state",
    class: "inline-block"
}, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = {
    key: 1,
    class: "table-auto bg-white mb-3 w-full rounded-md"
};
const _hoisted_11 = { class: "pl-2 border-r-1 border-gray" };
const _hoisted_12 = {
    key: 0,
    class: "pl-2 py-3"
};
const _hoisted_13 = {
    key: 1,
    class: "pl-2 py-3"
};
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminOrderLogs',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const logsLoading = (0, vue_3.ref)(false);
        const logValues = (0, vue_3.ref)([]);
        const totalLogs = (0, vue_3.ref)(0);
        const modalIsOpen = (0, vue_3.ref)(false);
        const modalValues = (0, vue_3.ref)([]);
        const modalValueLoading = (0, vue_3.ref)(false);
        const sortBy = 'id';
        const sortDesc = (0, vue_3.ref)(true);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "order_logs")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
            },
            {
                key: "createdAt",
                label: (_b = (0, i18n_1.trans)("date", "Date", "order_logs")) !== null && _b !== void 0 ? _b : "Date",
                value: "createdAt",
            },
            {
                key: "status",
                label: (_c = (0, i18n_1.trans)("status", "Status", "order_logs")) !== null && _c !== void 0 ? _c : "Status",
                value: "status",
                filterable: true,
            },
            {
                key: "action",
                label: (_d = (0, i18n_1.trans)("action", "Action", "order_logs")) !== null && _d !== void 0 ? _d : "Action",
                value: "action",
                filterable: true,
            },
            {
                key: "message",
                label: (_e = (0, i18n_1.trans)("message", "Message", "order_logs")) !== null && _e !== void 0 ? _e : "Message",
                value: "message",
                filterable: true,
            },
            {
                key: "userId",
                label: (_f = (0, i18n_1.trans)("user_id", "User id", "order_logs")) !== null && _f !== void 0 ? _f : "User id",
                value: "userId",
                filterable: true,
            },
            {
                key: "customerId",
                label: (_g = (0, i18n_1.trans)("customer_id", "Customer id", "order_logs")) !== null && _g !== void 0 ? _g : "Customer id",
                value: "customerId",
                filterable: true,
            },
            {
                key: "cartId",
                label: (_h = (0, i18n_1.trans)("cart_id", "Cart id", "order_logs")) !== null && _h !== void 0 ? _h : "Cart id",
                value: "cartId",
                filterable: true,
            },
            {
                key: "orderId",
                label: (_j = (0, i18n_1.trans)("order_id", "Order id", "order_logs")) !== null && _j !== void 0 ? _j : "Order id",
                value: "orderId",
                filterable: true,
            },
            {
                key: "actions",
                label: (_k = (0, i18n_1.trans)("extra", "Extra", "order_logs")) !== null && _k !== void 0 ? _k : "Extra",
            },
        ]);
        const viewDetails = (id) => {
            modalValueLoading.value = true;
            modalIsOpen.value = true;
            let l = logValues.value.length;
            for (let i = 0; i < l; i++) {
                if (id !== logValues.value[i].id) {
                    continue;
                }
                // megtalaltuk az adott id-t
                if ("undefined" !== typeof logValues.value[i].details) {
                    // ha van valami a details-ban, akkor mar lekerdeztuk valamikor
                    modalValues.value = logValues.value[i].details;
                    modalValueLoading.value = false;
                    return;
                }
                // ures a details, ujra le kell kerdezni
                break;
            }
            loadLogDetails(router, id)
                .then((details) => {
                let l = logValues.value.length;
                for (let i = 0; i < l; i++) {
                    if (id === logValues.value[i].id) {
                        logValues.value[i].details = details;
                    }
                }
                modalValues.value = details;
            })
                .finally(modalValueLoading.value = false);
        };
        const loadLogs = async (router, params = {}) => {
            var _a;
            logsLoading.value = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "admin_order_logs_api", query: params }).href);
                logValues.value = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'OrderLog') {
                            return;
                        }
                        logValues.value.push(element);
                    });
                }
                totalLogs.value = (_a = response["hydra:totalItems"]) !== null && _a !== void 0 ? _a : 0;
                // Ha minden lefutott, akkor frissítsük az URL-t is
                router.push({ name: 'admin_order_logs', query: params });
            }
            catch (error) {
                console.error("An error occurred while fetching orderLogs:", error);
                throw error;
            }
            finally {
                logsLoading.value = false;
            }
        };
        function loadLogDetails(router, id) {
            return (0, fetch_1.default)(router.resolve({ name: "admin_order_logs_details_api", params: { id } }).href);
        }
        (0, vue_3.onBeforeUnmount)(() => {
            logsLoading.value = false;
            logValues.value = [];
            totalLogs.value = 0;
        });
        (0, vue_3.watch)([listFields.value, page, itemsPerPage, sortDesc], async () => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            try {
                await loadLogs(router, {
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    order: {
                        [sortBy]: sortDesc.value ? "desc" : "asc",
                    },
                    ...filters,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((listFields).value = $event)),
                    items: logValues.value,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: logsLoading.value,
                    sortBy: sortBy,
                    "onUpdate:sortBy": _cache[1] || (_cache[1] = ($event) => ((sortBy) = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[2] || (_cache[2] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[4] || (_cache[4] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: totalLogs.value
                }, {
                    "cell-createdAt": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(log.createdAt.slice(0, 4)) + "-" + (0, vue_2.toDisplayString)(log.createdAt.slice(4, 6)) + "-" + (0, vue_2.toDisplayString)(log.createdAt.slice(6, 8)) + " " + (0, vue_2.toDisplayString)(log.createdAt.slice(8, 10)) + ":" + (0, vue_2.toDisplayString)(log.createdAt.slice(10, 12)) + ":" + (0, vue_2.toDisplayString)(log.createdAt.slice(12)), 1)
                    ]),
                    "cell-action": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(log.action), 1)
                    ]),
                    "cell-details": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(log.details), 1)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                onClick: ($event) => (viewDetails(log.id)),
                                class: "text-blue font-bold"
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view", "View", "order_logs")), 9, _hoisted_6)
                        ])
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" {# "),
                        (0, vue_2.createTextVNode)(" #} ")
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    onClose: _cache[5] || (_cache[5] = ($event) => (modalIsOpen.value = false)),
                    title: (0, vue_2.unref)(i18n_1.trans)('details', 'Details', 'order_logs')
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (modalValueLoading.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, _hoisted_9))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", _hoisted_10, [
                                (0, vue_2.createElementVNode)("tbody", null, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(modalValues.value, (modalValue, modalValueKey) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                            class: "border-b-1 last:border-b-0",
                                            key: modalValueKey
                                        }, [
                                            (0, vue_2.createElementVNode)("th", _hoisted_11, (0, vue_2.toDisplayString)(modalValueKey), 1),
                                            (typeof modalValue === 'object')
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_12, [
                                                    (0, vue_2.createElementVNode)("pre", null, (0, vue_2.toDisplayString)(JSON.stringify(modalValue, null, 2)), 1)
                                                ]))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_13, (0, vue_2.toDisplayString)(modalValue), 1))
                                        ]));
                                    }), 128))
                                ])
                            ]))
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
